import React from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  ArcElement,
  Legend,
  Title,
  Tooltip,
  Colors
} from "chart.js";
import { PieChartData } from "./interface";

ChartJS.register(
  CategoryScale,
  LinearScale,
  ArcElement,
  Legend,
  Title,
  Tooltip,
  Colors
);

export default function Piegraph({
  pieGraphProps,
}: {
  pieGraphProps: PieChartData[];
}) {
    console.log("Pie Graph Props are", pieGraphProps);
  const options = {
    plugins: {
      colors: {
        forceOverride: true,
      },
    },
  };
  const lineChartData = {
    labels: pieGraphProps.map(pie_item => pie_item.Name),

    datasets: [
      {
        data: pieGraphProps.map(pie_item => pie_item.Value),
        borderWidth: 1,
        // backgroundColor: "#7f26d3",
      },
    ],
    hoverOffset:4,
  };
  return <Pie options={options} data={lineChartData} />;
}
